import React from "react";
import { Helmet } from "react-helmet";

function SEO(props) {
  const { title, content, description, image, url, alt } = props;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        {/* Open Graph / Facebook */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={content || description} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={image} />
        <meta property="og:image:secure_url" content={image} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content={alt} />

        {/* Standard Meta Tags */}
        <meta name="description" content={content || description} />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={content || description} />
        <meta name="twitter:image" content={image} />

        {/* Google / Schema.org */}
        <meta itemProp="name" content={title} />
        <meta itemProp="description" content={content || description} />
        <meta itemProp="image" content={image} />
      </Helmet>
    </>
  );
}

export default SEO;
